import { forwardRef, useEffect, useRef } from "react";
import { mergeRefs } from "react-merge-refs";
import { View, ViewProps } from "react-native";

type Props = ViewProps;

export const FocusTrap = forwardRef<View, Props>((props, ref) => {
  const localRef = useRef<View>(null);

  useEffect(() => {
    const element = localRef.current;
    if (!(element instanceof HTMLElement)) {
      return;
    }

    element.focus();

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== "Tab") {
        return;
      }

      const focusableElements = element.querySelectorAll<HTMLElement>(
        "button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])",
      );
      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstFocusableElement) {
        lastFocusableElement?.focus();
        event.preventDefault();
        return;
      }

      if (!event.shiftKey && document.activeElement === lastFocusableElement) {
        firstFocusableElement?.focus();
        event.preventDefault();
        return;
      }
    };

    document.addEventListener("keydown", handleKeyDown, true);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return <View ref={mergeRefs([localRef, ref])} tabIndex={0} {...props} />;
});
